module.exports = __webpack_public_path__ + "img/limit2cn.9d4e5023.png";